import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "results" }
const _hoisted_2 = { class: "section-title large" }
const _hoisted_3 = { class: "description" }
const _hoisted_4 = { class: "filter-tabs" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "filter-content" }
const _hoisted_7 = {
  key: 0,
  class: "date-filter"
}
const _hoisted_8 = {
  key: 1,
  class: "game-filter"
}
const _hoisted_9 = { value: "" }
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  key: 2,
  class: "draw-filter"
}
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = { class: "results-grid" }
const _hoisted_14 = {
  key: 0,
  class: "load-more"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }

import { ref, computed, watch, onMounted } from 'vue'

import LotteryResultCard from '@/components/LotteryResultCard.vue'
import NextDrawsFilter from '@/components/NextDrawsFilter.vue'
import { useResultsStore } from '@/stores/results'
import { useGameStore } from '@/stores/game'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
const RESULTS_PER_PAGE = 10;

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'ResultsView'
},
  __name: 'ResultsView',
  setup(__props) {



const showDatePicker = ref(false);
const gameStore = useGameStore()
const resultsStore = useResultsStore();
const router = useRouter()
const { t } = useI18n()

const tabs = computed(() => [
  { id: 'by-date', label: t('results.byDate') },
  { id: 'by-lottery', label: t('results.byGame') },
  { id: 'by-drawid', label: t('results.byDrawId') }
]);

const activeTab = ref('by-lottery'); // Default to BY GAME
const selectedDate = ref(new Date().toISOString().split('T')[0]);
const selectedGame = ref('');
const drawId = ref('');

const currentPage = ref(1);

const paginatedResults = computed(() => {
  const start = (currentPage.value - 1) * RESULTS_PER_PAGE;
  const end = start + RESULTS_PER_PAGE;
  return resultsStore.results.slice(0, end);
});

const hasMoreResults = computed(() => {
  return resultsStore.results.length > paginatedResults.value.length;
});

const loadMore = () => {
  if (hasMoreResults.value) {
    currentPage.value += 1;
  }
};

const handleDateFilter = (date: string) => {
  selectedDate.value = date || new Date().toISOString().split('T')[0];
};

const handleBet = async (game: any) => {
  if (!game?.game_slug) return
  await gameStore.fetchGameDetails(game.game_slug)
  router.push(`/lottery/${game.game_slug}`)
}

const gamesList = computed(() => {
  // Use game store to show ALL games, not just games with results
  const allGames = gameStore.getProducts || [];
  if (!Array.isArray(allGames)) return [];
  
  // Sort games alphabetically by name
  return [...allGames].sort((a, b) => {
    const nameA = a.name?.toLowerCase() || '';
    const nameB = b.name?.toLowerCase() || '';
    return nameA.localeCompare(nameB);
  });
});

watch(activeTab, (newTab, oldTab) => {
  if (oldTab === 'by-lottery' && newTab !== 'by-lottery') {
    selectedGame.value = '';
  }
});

watch(
  [activeTab, selectedDate, selectedGame, drawId],
  () => {
    currentPage.value = 1;
    const filters: any = {
      drawDate: '',
      drawId: '',
      drawType: '',
      gameSlug: ''
    };

    if (activeTab.value === 'by-date') {
      filters.drawType = 'by-date';
      filters.drawDate = selectedDate.value || '';
    } else if (activeTab.value === 'by-lottery') {
      filters.drawType = 'by-lottery';
      filters.gameSlug = selectedGame.value || '';
    } else if (activeTab.value === 'by-drawid') {
      filters.drawType = 'draw';
      filters.drawId = drawId.value || '';
    }

    resultsStore.setFilters(filters);
    resultsStore.fetchResults(1);
  }
);

onMounted(async () => {
  // await authStore.authenticate()
  // Fetch all products (games) to populate the dropdown immediately
  if (!gameStore.getProducts || gameStore.getProducts.length === 0) {
    await gameStore.fetchProducts();
  }
  // Set filters for BY GAME mode by default
  resultsStore.setFilters({ 
    drawType: 'by-lottery',
    gameSlug: selectedGame.value || ''
  });
  resultsStore.fetchResults(1);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('results.title')), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('results.description')), 1),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
        return (_openBlock(), _createElementBlock("button", {
          key: tab.id,
          class: _normalizeClass(["tab-button", { active: activeTab.value === tab.id }]),
          onClick: ($event: any) => (activeTab.value = tab.id)
        }, _toDisplayString(tab.label), 11, _hoisted_5))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_6, [
      (activeTab.value === 'by-date')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(NextDrawsFilter, {
              modelValue: selectedDate.value,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((selectedDate).value = $event)),
                handleDateFilter
              ],
              "show-date-picker": showDatePicker.value,
              "allow-past": true
            }, null, 8, ["modelValue", "show-date-picker"])
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 'by-lottery')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedGame).value = $event)),
              class: "game-select"
            }, [
              _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.$t('results.allGames')), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gamesList.value, (game) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: game.slug,
                  value: game.slug
                }, _toDisplayString(game.name), 9, _hoisted_10))
              }), 128))
            ], 512), [
              [_vModelSelect, selectedGame.value]
            ])
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 'by-drawid')
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((drawId).value = $event)),
              type: "text",
              placeholder: _ctx.$t('results.enterDrawId'),
              class: "draw-input"
            }, null, 8, _hoisted_12), [
              [_vModelText, drawId.value]
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_13, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedResults.value, (result) => {
        return (_openBlock(), _createBlock(LotteryResultCard, {
          key: result.id,
          lottery: result,
          onBet: ($event: any) => (handleBet(result))
        }, null, 8, ["lottery", "onBet"]))
      }), 128))
    ]),
    (hasMoreResults.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("button", {
            class: "load-more-button",
            onClick: loadMore
          }, _toDisplayString(_ctx.$t('results.loadMore')), 1)
        ]))
      : _createCommentVNode("", true),
    (_unref(resultsStore).loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.$t('common.loading')), 1))
      : (_unref(resultsStore).error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(resultsStore).error), 1))
        : _createCommentVNode("", true)
  ]))
}
}

})